import { getDomainUrl } from 'core/utils';

export const elementTemplateListPath = () => '/company/elements/list';

export const elementTemplateDetailsPath = (id: number | string = ':id') =>
  `/company/elements/${id}`;

export const oldElementTemplateDetailsPath = (
  elementTemplateId: number | string = ':elementTemplateId'
) => `${getDomainUrl()}/element/template/materials?element_template=${elementTemplateId}`;
